import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import styles from "./bigScreen.less";

function CloudName(props) {
  const { clouds, model, getCloudId, defaultcloudid } = props;
  const [cloudName, setCloudName] = useState("");
  const [cloudsListFlag, setCloudsListFlag] = useState(false); // 云列表是否展开
  const [defaultCloudName, setDefaultCloudName] = useState("");
  const [scrollIndex, setScollIndex] = useState(null); // 选中云index
  const cloudsListRef = useRef(null);

  useEffect(() => {
    cloudsListFlag && document.addEventListener("click", onClickOutSide, false);
    if (cloudsListFlag) {
      // 滚动到可是区域， 添加选中背景index
      const cloudsEleList = cloudsListRef.current.getElementsByClassName('cloud')
      cloudsEleList.forEach((item, index) => {
        if (index === scrollIndex) {
          item.scrollIntoView({behavior: 'smooth', block: 'center'})
          item.className = `${styles.cloud} cloud ${styles.activecloud}`
        } else {
          item.className = `${styles.cloud} cloud`
        }
      })
    }
    return () => {
      document.removeEventListener("click", onClickOutSide, false);
    };
  }, [cloudsListFlag]);

  useEffect(() => {
    clouds &&
      clouds.forEach((item, index) => {
        if (item.id === defaultcloudid) {
          setDefaultCloudName(item.name);
          setScollIndex(index)
          // model.invoke("listapp", `{"bizcloudid": "${item.id}"}`);
          return;
        }
      });
  }, [defaultcloudid]);

  // 点击位置在下拉外，关闭下拉
  const onClickOutSide = function (ev) {
    console.log(1111, ev.target);
    if (
      ev.target !== cloudsListRef.current &&
      ev.target.parentElement !== cloudsListRef.current
    ) {
      setCloudsListFlag(false);
      document.removeEventListener("click", onClickOutSide, false);
    }
  };

  const handleClick = (id, name, e) => {
    document.removeEventListener("click", onClickOutSide, false);
    // 记录下选中云的index
    const cloudtest = cloudsListRef.current.getElementsByClassName('cloud')
    cloudtest.forEach((item, index) => {
      item === e.target && setScollIndex(index)
    })
    model.invoke("listapp", `{"bizcloudid": "${id}"}`);
    setCloudName(name);
    setCloudsListFlag(false);
    getCloudId(id);
  };

  const getCloudsList = () => {
    model.invoke("listcloud");
    setCloudsListFlag(true);
  };

  const cloudsList = cloudsListFlag ? (
    <div className={styles.cloudsList} ref={cloudsListRef}>
      <div className={styles.cloudsListContainer}>
        {clouds.map((item) => (
          <div
            className={`${styles.cloud} cloud`}
            onClick={(e) => handleClick(item.id, item.name, e)}
          >
            {item.name}
          </div>
        ))}
      </div>
    </div>
  ) : null;

  return (
    <div className={styles.cloudName}>
      <div className={styles.cloudNameContainer} onClick={getCloudsList}>
        <span className={styles.textGradient} id="cloudName">
          {cloudName || defaultCloudName}
        </span>
        <span
          className={`${styles.cloudNameSelect} ${
            cloudsListFlag ? styles.cloudNameSelectTans : null
          }`}
          id="cloudNameSelect"
        ></span>
      </div>
      {cloudsList}
    </div>
  );
}
CloudName.propTypes = {
  // baseinfo: PropTypes.object,
  // name: PropTypes.string
};
export default CloudName;
